import {Link, useLocation} from 'react-router-dom'
import {HashLink} from 'react-router-hash-link'
import {canonicalPath, landingPages} from '../Seo/siteContent'
import './TopBanner.scss'
import ImgTelegramLogo from '../../assets/img/telegram-logo.svg'
import ImgWhatsappLogo from '../../assets/img/whatsapp-logo.svg'

export default function TopBanner() {
    const path = canonicalPath(useLocation().pathname)
    const page = landingPages[path] || landingPages['/']
    return <section className="TopBanner">
        <div className="TopBanner__content">
            <div className="phone-call">
                {path !== '/' && <nav className="TopBanner__breadcrumbs" aria-label="Хлебные крошки">
                    <ol><li><Link to="/">Главная</Link></li><li aria-current="page">{page.label}</li></ol>
                </nav>}
                <h1>{page.h1}</h1>
                <p className="TopBanner__lead">{page.lead}</p>
                <div className="TopBanner__actions">
                    <HashLink smooth to={path + '#qq-trip-calculator'} className="TopBanner__calculate">Рассчитать стоимость <span aria-hidden="true">↓</span></HashLink>
                    <a href="tel:+79507007071" className="TopBanner__phone">8 950 700-70-71</a>
                </div>
            </div>
            <div className="socials-wrapper">
                <div className="text">Или напишите нам в</div>
                <a href="https://t.me/taxiFLEEKA" target="_blank" rel="noreferrer"><img height="24" src={ImgTelegramLogo} alt="" /><span>Telegram</span></a>
                <div className="text">или</div>
                <a href="https://wa.me/79507007071" target="_blank" rel="noreferrer"><img height="24" src={ImgWhatsappLogo} alt="" /><span>WhatsApp</span></a>
            </div>
        </div>
    </section>
}
